import BrowserStore from 'store';
import Axios from 'axios';

const get_default_locale = () => {
  if (BrowserStore.get('locale')) {
    return BrowserStore.get('locale');
  }

  const language = window.navigator
    ? window.navigator.language || window.navigator.systemLanguage || window.navigator.userLanguage
    : 'en';

  return language.substr(0, 2).toLowerCase();
};

const state = {
  value: get_default_locale(),
  available: [
    { value: 'en', label: 'English' },
    { value: 'ru', label: 'Русский' },
    { value: 'ja', label: '日本語' }
  ]
};

const actions = {
  change({ commit }, locale) {
    commit('change', locale);
  }
};

const mutations = {
  change(state, locale) {
    state.value = locale;
    BrowserStore.set('locale', state.value);
    Axios.defaults.headers.common['Accept-Language'] = state.value;
  }
};

const getters = {
  current(state) {
    return state.value;
  },

  is_japan_locale(state) {
    return state.value === 'ja';
  },

  defaultManagerEmail(state) {
    let defaultEmail = '';

    if (state.value === 'ru') {
      defaultEmail = 'clientsupport@vcv.ru';
    } else if (this.locale === 'ja') {
      defaultEmail = 'jpsupport@vcv.co.jp';
    } else {
      defaultEmail = 'hey@vcv.ai';
    }
    return defaultEmail;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
